<template>
  <div class="modal-overflow row">
    <div class="col-md-9">
      <process-definition-b-p-m-n :data="data.processDefinitions[0]"></process-definition-b-p-m-n>
    </div>
    <div class="col-md-3">
      <process-definitions :data="data" @close="() => $emit('close')"></process-definitions>
    </div>
  </div>
</template>

<script>
  import ProcessDefinitionBPMN from './ProcessDefinitionBPMN'
  import ProcessDefinitions from './ProcessDefinitions'
  export default {
    props: ['data'],
    components: {
      ProcessDefinitionBPMN,
      ProcessDefinitions
    },
    mounted() {
      this.$eventHub.$on('camundaDeploymentArchived', () => this.$emit('close'))
      this.$eventHub.$on('camundaDeploymentDeleted', () => this.$emit('close'))
    },
    destroyed() {
      this.$eventHub.$off('camundaDeploymentArchived')
      this.$eventHub.$off('camundaDeploymentDeleted')
    }
  }
</script>
